import setSiteMeta from '../base-saving-actions/set-site-meta';

export default function updateCurrentButtonPresetVersion(initialVersion, newVersion) {
  return initialVersion !== newVersion
    ? [setSiteMeta(['customization', 'currentButtonPresetVersion'], newVersion)]
    : [];
}
